/* eslint-disable react/jsx-props-no-spreading */
import React, { memo } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import './mini-file-upload.scss';
import Button, { ButtonTypes } from '../../../button/button';

const MiniFileUpload = ({
  disabled, primaryMsg, buttonProps,
}) => (
  <div className={clsx('fumc-section', { disabled })}>
    <Button
      disabled={disabled}
      className="mini-file-upload-btn"
      {...buttonProps}
      label={primaryMsg}
    />
  </div>
);

MiniFileUpload.defaultProps = {
  primaryMsg: '',
  disabled: false,
  buttonProps: {
    type: ButtonTypes.TERTIARY,
  },
};

MiniFileUpload.propTypes = {
  disabled: PropTypes.bool,
  primaryMsg: PropTypes.string,
  buttonProps: PropTypes.shape(Button.propTypes),
};

export default memo(MiniFileUpload);
